import { useState } from "react";
import { Box, Fade, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomColoredTabs } from "../CustomColoredTabs/CustomColoredTabs.component";
import { CustomColoredTab } from "../CustomColoredTabs/CustomColoredTab.component";
import { TabPanel } from "../../features/TabPanel/TabPanel.component";
import { a11yProps } from "../../features/TabPanel/TabPanel.partial";
import { NotificationSettingList } from "./NotificationSettingList.component";

export function NotificationSettingsPage() {
  const theme = useTheme();
  const { t } = useTranslation();

  const [tabState, setTabState] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent<{}>, newValue: number) =>
    setTabState(newValue);

  return (
    <Fade in>
      <Box
        sx={{ "& > *": { margin: theme.spacing(1) } }}
        data-testid="notification-settings-page-parent"
      >
        <CustomColoredTabs value={tabState} onChange={handleTabChange}>
          <CustomColoredTab
            index={0}
            data-testid={"notification-settings-tab"}
            label={t("NotificationSettingTabHeader")}
            {...a11yProps(0)}
          />
        </CustomColoredTabs>
        {/* list of catering service */}
        <TabPanel value={tabState} index={0}>
          <NotificationSettingList />
        </TabPanel>
      </Box>
    </Fade>
  );
}
